import { actionCreator } from 'utils';
import * as HistoryTypes from '../types/historyTypes';

export function loadHistory(stream) {
    return {
        type: HistoryTypes.LOAD_HISTORY,
        stream,
    };
}

export function loadHistoryRes(data) {
    return {
        type: actionCreator(HistoryTypes.LOAD_HISTORY, 'res'),
        data,
    };
}

export function loadHistoryErr() {
    return {
        type: actionCreator(HistoryTypes.LOAD_HISTORY, 'err'),
    };
}

export function removeHistory() {
    return {
        type: HistoryTypes.REMOVE_HISTORY,
    };
}

export function setHistoryPagination(key, pagination) {
    return {
        type: HistoryTypes.SET_HISTORY_PAGINATION,
        key,
        pagination,
    };
}

export function loadDisplayUsersHistory(data) {
    return {
        type: HistoryTypes.LOAD_DISPLAY_USERS_HISTORY,
        data,
    };
}
